

export default {
    index: [
        {
            path: '/SysUserAdmin',
            component: resolve => require(['./SysUserIndex.vue'], resolve),
        },
        {
            path: '/SysRoleAdmin',
            component: resolve => require(['./SysRoleIndex.vue'], resolve),
        }, {
            path: '/SysLogAdmin',
            component: resolve => require(['./SysLogIndex.vue'], resolve),
        }, {
            path: '/SysMenuAdmin',
            component: resolve => require(['./SysMenuIndex.vue'], resolve),
        }, {
            path: '/SysRoleUserAdmin',
            component: resolve => require(['./SysRoleUserIndex.vue'], resolve),
        }, {
            path: '/sysTypeAdmin',
            component: resolve => require(['./SysTypeIndex.vue'], resolve),
        }, {
            path: '/sysArea',
            component: resolve => require(['./SysAreaIndex.vue'], resolve),
        }, {
            path: '/sysConfigAdmin',
            component: resolve => require(['./sysConfigIndex.vue'], resolve),
        }, {
            path: '/DbCompareIndex',
            component: resolve => require(['./DbCompareIndex.vue'], resolve),
        }, {
            path: '/sysFile',
            component: resolve => require(['./sysFileIndex.vue'], resolve),
        }/*, {
            path: '/sysDelelebackup',
            component: resolve => require(['./sysDelelebackupIndex.vue'], resolve),
        }, {
            path: '/sysException',
            component: resolve => require(['./sysExceptionIndex.vue'], resolve),
        }*/
    ]
}



// WEBPACK FOOTER //
// ./src/view/sys/_router.js